import React, { useState, useContext, useEffect } from 'react'
import { jwtDecode } from "jwt-decode"
import { Link } from "react-router-dom"
import { NormasContext } from '../../context/NormasContext'
import "../../pages/Normas/ListaProyectos.scss"
import "./VistaEmpresaNormas.scss"
import IllustrationAccess from "../../assets/img/access.png"
import ModalNewProyectoEmpresa from '../Modales/Normas/ModalNewProyectoEmpresa'
// ui
import { Oval } from 'react-loader-spinner'
import Card from "../../components/ui/Card"

function VistaEmpresaNormas(props) {

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const user = jwtParse?.apirest?.objeto

    const { status, proyectosNormas, fetchProyectosNormas } = useContext(NormasContext)

    const [modalProyecto, setModalProyecto] = useState(false)
    
    useEffect(() => {
        fetchProyectosNormas({
            user: props.user,
            idEmpresa: parseInt(props.user.idEmpresa)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const handleModalProyecto = () => {
        setModalProyecto(true)
    }

    return (
        <>
            <ModalNewProyectoEmpresa show={modalProyecto} onHide={()=>setModalProyecto(false)} />
            <div className='normas section'>
                {status.proyectos.loading ? (
                    <div className='loading__normas d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                        visible={true}
                        height="80"
                        width="80"
                        color="#0d6efd"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        />
                        <p className='fw-medium'>Loading...</p>
                    </div>
                ) : (
                    <>
                        {status.proyectos.error ? (
                            <div className='normas--errorGerente d-flex flex-column align-items-center justify-content-center rounded-3 mb-4'>
                                <img className='mb-4' src={IllustrationAccess} alt="" />
                                <h2 className='text-danger mb-1'>Oops!</h2>
                                <p>{status.proyectos.error}</p>
                                <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/normas"}>Regresar a Normas ISO</Link>
                            </div>
                        ) : (
                            <>
                                {proyectosNormas?.objeto?.length === 0 ? (
                                    <div className='normas--emptyGerente d-flex flex-column align-items-center justify-content-center rounded-3 p-4'>
                                        <h2 className='text-blue-500 fw-semibold mb-1 text-center'>No tienes proyectos aún.</h2>
                                        {/* AGREGAR EVIDENCIAS - PUESTO ADMIN CONSULTORA Y GERENTE */}
                                        {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                                            <>
                                            <p className='mb-3 text-center'>Para comenzar, crea tu primer proyecto:</p>
                                            <button className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' 
                                                onClick={handleModalProyecto}>
                                                + agregar proyecto
                                            </button>
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <div className='proyectos proyectos--100h scroll--y'>
                                        {proyectosNormas?.objeto?.map((p) => (
                                        <Card 
                                            key={p.id_proyecto_norma}
                                            nombre={p.nombre}
                                            estado={p.estado}
                                            usuario={p.Creador?.nombre}
                                            fecha={p.fecha_inicio?.replace(/-/g, '/').split("/").reverse().join("/")}
                                            link={`/normas/proyecto/${p.id_proyecto_norma}`}
                                            progreso={p.porcentaje}
                                        />
                                        ))}
                                        {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                                            <>
                                                <div className='card--new p-3 d-flex flex-column align-items-center justify-content-center rounded-3'>
                                                    <button className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' 
                                                    onClick={handleModalProyecto}>
                                                        + agregar proyecto
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export default VistaEmpresaNormas